import * as Yup from "yup";
import { VALIDATION_KEYS } from '../../utils/translation-constants'
import validationConfig from "custom/config/validation.config.json";
const depositConfig = validationConfig["deposit"];

const validateAccountNo = depositConfig["isAccountNoRequired"]
  ? {
    debitAccNo: Yup.string().required(VALIDATION_KEYS.SOURCE_ACCOUNT_NO_REQUIRED),
    }
  : {
      debitAccNo: Yup.string().optional(),
    };
const validateAmount = depositConfig["isAmountRequired"]
  ? {
    amount: Yup.string().required(VALIDATION_KEYS.AMOUNT_REQUIRED),
    }
  : {
      amount: Yup.string().optional(),
    };
const validateInterestCredit = depositConfig["isInterestCreditRequired"]
  ? {
    interestCredit: Yup.string().required(VALIDATION_KEYS.INTERST_CREDIT),
    }
  : {
      interestCredit: Yup.string().optional(),
    };
const validateTenorPeriod = depositConfig["isAccountNoRequired"]
  ? {
    tenorPeriod: Yup.string().required(VALIDATION_KEYS.TENURE_REQUIRED),
    }
  : {
      tenorPeriod: Yup.string().optional(),
    };
const validateCurrency = depositConfig["isCurrencyRequired"]
  ? {
    toCurrency: Yup.string().required(VALIDATION_KEYS.CURRENCY_REQUIRED),
    }
  : {
      toCurrency: Yup.string().optional(),
    };

    const validateCreditAccountNo = depositConfig["isAccountNoRequired"]
  ? {
    creditAccNo: Yup.string().required(VALIDATION_KEYS.CREDIT_ACCOUNT_NO_REQUIRED),
    }
  : {
      creditAccNo: Yup.string().optional(),
    };

    const validateTenureValue = depositConfig["isAccountNoRequired"]
    ? {
      tenorValue: Yup.string().required(VALIDATION_KEYS.TENURE_VALUE_REQUIRED),
      }
    : {
        tenorValue: Yup.string().optional(),
      };

// eslint-disable-next-line import/prefer-default-export
export const CreateTermDepositSchema = Yup.object().shape({
  ...validateAccountNo,
  ...validateAmount,
  ...validateTenorPeriod,
  ...validateInterestCredit,
  ...validateCurrency,
  ...validateCreditAccountNo,
  ...validateTenureValue
});
